import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Box } from 'foundations-components/transitional/components/Box';
import PlaylistNavigationDropdown from '../../playlistContent/components/PlaylistNavigationDropdown';
import { H2 } from 'foundations-components/transitional/components/H2';
import { useHasGate } from '../../accounts/accountsQueries';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const LearningContentPageHeader = ({
  title,
  item,
  children
}) => {
  const {
    isDesktop
  } = useMediaQuery();
  const {
    hasGate: hasUnifiedAcademy
  } = useHasGate('Academy:UnifiedAcademy:Navigation');
  return /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    backgroundColor: "fill-surface-default",
    borderBlockEndColor: "border-core-default",
    borderBlockEndStyle: "solid",
    borderBlockEndWidth: "100",
    direction: "row",
    insetBlockStart: hasUnifiedAcademy ? '0' : '48px',
    margin: "0",
    minBlockSize: isDesktop ? '76px' : '60px',
    paddingBlock: "400",
    paddingInline: !isDesktop ? '300' : hasUnifiedAcademy ? undefined : '600',
    position: "sticky",
    wrap: "nowrap",
    zIndex: 2,
    children: [/*#__PURE__*/_jsxs(TFlex, {
      direction: "column",
      children: [item && !!item.playlistId && /*#__PURE__*/_jsx(PlaylistNavigationDropdown, {
        item: item
      }), /*#__PURE__*/_jsx(H2, {
        flex: 1,
        margin: "0",
        typography: !isDesktop ? 'body-200' : undefined,
        children: title
      })]
    }), children && /*#__PURE__*/_jsx(Box, {
      children: /*#__PURE__*/_jsx(TFlex, {
        align: "center",
        gap: 12,
        children: children
      })
    })]
  });
};